import { render } from "./ClomosView.vue?vue&type=template&id=502c1399"
import script from "./ClomosView.vue?vue&type=script&lang=js"
export * from "./ClomosView.vue?vue&type=script&lang=js"

import "./ClomosView.vue?vue&type=style&index=0&id=502c1399&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__